<template>
  <div ref="completionCont" class="completion__container container p-2 m-0" :class="'completion_' + widgetIndex">
    <p v-show="!loaded" class="no__data loading">Loading...</p>
    <p v-if="loaded && emptyData" class="no__data">No Data Available</p>
    <div v-if="loaded && !emptyData" class="completion__list row m-0">
      <div v-for="(item, shipment) in summaries"
        class="col-12 row bg-light mr-0 ml-0 p-0"
        :class="{ 'mb-3': shipment !== summaries.length - 1 }"
        :key="item.id">
        <div class="col-md-2 col-sm-12 p-0 percentage__cont bg-dark">
          <div class="col-12 text-center shipment__percentage">
            <p class="text-light">{{ item.total_percentage }}<span>&nbsp;%</span></p>
          </div>
          <div class="col-12 text-center">
            <router-link :to="`/employees/${get(item, 'driver.id')}`" class="text-light">
              {{ get(item, 'driver.name') }}
            </router-link>
          </div>
          <div class="col-12 text-center shipment__number text-light">
            No.
            <router-link :to="`/shipment_md/shipments/${item.id}`" class="text-secondary">
              {{ item.number }}
            </router-link>
          </div>
        </div>
        <div class="col-md-10 col-sm-12 text-center row m-0 p-0 progress__cont">
          <div @click="moveLeft(shipment)" class="control-button bg-light text-center control-left">
            <span class="left fa fa-chevron-circle-left"></span>
          </div>
          <div style="width: 96%; padding: 0 20px 0 20px;" class="journey align-items-center d-flex flex-row flex-nowrap" ref="journey">
            <div v-for="(job, bar) in item.destinations" :id="'job' + bar" class="journey__job"
              v-if="item.destinations[bar].percentage !== undefined"
              :class="{
                'journey--pending':
                  item.destinations[bar].percentage === 0 &&
                  (bar !== 0 && item.destinations[bar - 1].percentage < 100) ||
                  (bar !== 0 && item.destinations[bar - 1].percentage < 100),
                'journey--progress show-marker':
                  item.destinations[bar].percentage >= 0 &&
                  item.destinations[bar].percentage < 100 &&
                  ((bar !== 0 && item.destinations[bar - 1].percentage === 100) || bar === 0),
                'journey--complete':
                  !checkLastComplete(bar, item.destinations) &&
                  item.destinations[bar].percentage === 100,
                'last--complete':
                  checkLastComplete(bar, item.destinations) &&
                  item.destinations[bar].percentage === 100,
              }"
              :style="'width :' + calculateBarWidth(item) + '%;'" :key="job.id">
              <div :ref="`journey__bar--${shipment}${bar}`" class="journey__bar" :style="{ width: item.destinations[bar].percentage + '%' }">
                <div class="journey__marker" :id="`journey__marker${shipment}${bar}`" tabindex="0"></div>
                <b-popover placement="bottom" :target="`journey__marker${shipment}${bar}`" triggers="hover">
                  Click To See Latest Position
                </b-popover>
                <b-popover placement="bottom" :target="`journey__marker${shipment}${bar}`" triggers="focus">
                  <template slot="title">Latest Position</template>
                  <ul class="list-group list-group-flush list-group--full p-2">
                    <li class="list-group-item p-1 pt-2 pb-2">
                      Address : <strong>{{ get(item.vehicle, 'gps_devices.0.gps_info.road_name') }}</strong>
                    </li>
                    <li class="list-group-item p-1 pt-2 pb-2">
                      Latitude : <strong>{{ get(item.vehicle, 'gps_devices.0.gps_info.latitude') }}</strong>
                    </li>
                    <li class="list-group-item p-1 pt-2 pb-2">
                      Longitude : <strong>{{ get(item.vehicle, 'gps_devices.0.gps_info.longitude') }}</strong>
                    </li>
                  </ul>
                </b-popover>
                <div class="journey__percentage" tabindex="0">
                  <b-badge pill variant="warning">{{ (item.destinations[bar] || {}).percentage }}%</b-badge>
                </div>
                <div class="journey__percentage--bottom" tabindex="1">
                  <b-badge pill variant="success">{{ Math.floor(summaries[shipment].total_percentage) }}%</b-badge>
                </div>
              </div>
              <div class="dot dot--first" :id="`dot--first--${shipment}${bar}`" v-if="bar === 0" tabindex="0"></div>
              <b-popover placement="bottom" :target="`dot--first--${shipment}${bar}`" triggers="hover focus">
                <template slot="title">Origin</template>
                <ul class="list-group list-group-flush list-group--full p-2">
                  <li class="list-group-item p-1 pt-2 pb-2">
                    Code : <strong>{{ item.origin.code }}</strong>
                  </li>
                  <li class="list-group-item p-1 pt-2 pb-2">
                    Name : <strong>{{ item.origin.name }}</strong>
                  </li>
                  <li class="list-group-item p-1 pt-2 pb-2">
                    Address : <strong>{{ item.origin.metadata.info.address }}</strong>
                  </li>
                </ul>
              </b-popover>
              <div class="dot dot--last" :id="`dot--last--${shipment}${bar}`" tabindex="0"></div>
              <b-popover placement="bottom" :target="`dot--last--${shipment}${bar}`" triggers="hover">
                Click To See Job Detail
              </b-popover>
              <b-popover placement="bottom" :target="`dot--last--${shipment}${bar}`" triggers="focus">
                <template slot="title">Job Detail</template>
                <b-card no-body class="text-center mb-3 p-2">
                  {{ get(job, 'orders[0].customer.name') }}<br>{{ job.address }}
                </b-card>
                <b-tabs>
                  <b-tab v-for="(piece, pieceNum) in job.orders" :title="(pieceNum + 1).toString()" :key="piece.id">
                    <ul class="list-group list-group-flush list-group--full">
                      <li class="list-group-item p-1 pt-2 pb-2">
                        Order Number : <strong>{{ piece.number }}</strong>
                      </li>
                      <li class="list-group-item p-1 pt-2 pb-2">
                        Status : <strong>{{ piece.status }}</strong>
                      </li>
                      <li class="list-group-item p-1 pt-2 pb-2">
                        <div class="text-center"><strong>Units</strong></div>
                        <hr class="m-1">
                        <ul class="list-group list-group-flush">
                          <li v-for="unit in piece.units" class="list-group-item units__container" :key="unit.number">
                            {{ unit.number }} - {{ unit.type }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </b-tab>
                </b-tabs>
              </b-popover>
            </div>
          </div>
          <div @click="moveRight(shipment)" class="control-button bg-light text-center control-right">
            <span class="right fa fa-chevron-circle-right"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isEmpty, get } from 'lodash';
import { format } from 'date-fns';

export default {
  name: 'completion_items',
  data() {
    return {
      loaded: false,
      recursive: null,
      allShipments: [],
      summaries: [],
      transform: 0,
      lastDataAr: [],
      lastData: null,
      currentPage: 1,
      filterState: ['ON_PROCESS', 'CREATED', 'FINISH', 'FINISH_LOADING'],
    };
  },
  created() {
    this.$store.commit('shipment_md/shipments/CLEAR_QUERY');
    this.$store.dispatch('shipment_md/shipments/LOAD_INFO').then(() => {
      // this.$store.commit('shipment_md/shipments/SET_QUERY_COUNT', this.countAll);
      this.$store.commit('shipment_md/shipments/SET_COMPANY_ID', this.myCompany);
      this.$store.commit('shipment_md/shipments/SET_STATE_FILTER', this.filterState);
      this.$store.dispatch('shipment_md/shipments/LOAD_DATA_COMPLETION').then((all) => {
        this.allShipments = all;
        this.loadData().then(() => {
          this.setupHeight();
          this.recursiveLoadProgress();
        });
      });
    });
  },
  props: {
    widgetIndex: {
      type: String,
      required: true,
    },
  },
  beforeDestroy() {
    clearTimeout(this.recursive);
  },
  computed: {
    shipments() {
      return this.$store.getters['shipment_md/shipments/shipments'];
    },
    allPage() {
      return Math.ceil(this.allShipments.length / 3);
    },
    countAll() {
      return this.$store.getters['shipment_md/shipments/count_all'];
    },
    myCompany() {
      return this.$store.getters.currentCompany;
    },
    userData() {
      return this.$store.getters.userData;
    },
    emptyData() {
      return isEmpty(this.summaries);
    },
    prevDisabled() {
      return this.lastData === null;
    },
    nextDisabled() {
      return this.currentPage === this.allPage;
    },
  },
  methods: {
    get(object, key) {
      return get(object, key) || '';
    },
    checkLastComplete(i, dt) {
      let isLast = false;
      if (!isEmpty(dt)) { isLast = i === dt.length - 1; }
      return isLast;
    },
    recursiveLoadProgress(prefix = 'LOAD_SUMMARY') {
      clearTimeout(this.recursive);
      this.recursive = setTimeout(() => {
        this.$store.dispatch(`shipment_md/shipments/${prefix}`).then((summary) => {
          this.setSummaries(summary);
          this.recursiveLoadProgress(prefix);
        });
      }, 15e3);
    },
    loadData() {
      this.$store.commit('shipment_md/shipments/SET_QUERY_LAST_DATA', this.lastData);
      this.$store.commit('shipment_md/shipments/SET_COMPANY_ID', this.myCompany);
      this.$store.commit('shipment_md/shipments/SET_STATE_FILTER', this.filterState);
      return this.$store.dispatch('shipment_md/shipments/LOAD_DATA_COMPLETION').then(() => {
        this.loaded = false;

        this.$store.dispatch('shipment_md/shipments/LOAD_SUMMARY').then((summary) => {
          this.setSummaries(summary);
          this.loaded = true;
        });
      });
    },
    setSummaries(newData) {
      const dtPush = [];

      if (!isEmpty(newData)) {
        newData.forEach((shipment) => {
          const isOnProcess = shipment.total_percentage < 100;
          const updateToday = format(new Date(), 'YYYY-MM-DD') === format(shipment.updated_at, 'YYYY-MM-DD');
          const todayFinish = updateToday && shipment.total_percentage === 100;

          if (isOnProcess || todayFinish) dtPush.push(shipment);
        });

        this.summaries = dtPush;
      }
    },
    calculateBarWidth(item) {
      return Math.round(100 / item.destinations.length);
    },
    moveRight(shipment) {
      const journey = this.$refs.journey[shipment];
      const child = journey.childNodes;
      const length = child[0].offsetWidth * Object.keys(child).length;

      if (length - (journey.offsetWidth - 30) > 1) {
        if ((length - (journey.offsetWidth - 30)) + this.transform > 190) {
          this.transform -= 190;
        } else {
          this.transform -= (length - (journey.offsetWidth - 30)) + this.transform;
        }
      }

      /* eslint-disable array-callback-return */
      Object.keys(child).map((index) => {
        if (child[index].style.transform !== undefined &&
            child[index].style.transform !== null &&
            child[index].style.transform > 0) {
          this.transform = parseInt(child[index].style.transform.split('(')[1].split('px')[0], 10);
        }

        child[index].style.transform = `translate(${this.transform}px,0)`;
      });
    },
    moveLeft(shipment) {
      const journey = this.$refs.journey[shipment];
      const child = journey.childNodes;

      if (this.transform < -1) {
        if (this.transform < -190) {
          this.transform += 190;
        } else {
          this.transform -= this.transform;
        }
      }

      /* eslint-disable array-callback-return */
      Object.keys(child).map((index) => {
        if (child[index].style.transform !== undefined &&
            child[index].style.transform !== null &&
            child[index].style.transform > 0) {
          /* eslint-disable radix */
          this.transform = parseInt(child[index].style.transform.split('(')[1].split('px')[0]);
        }

        child[index].style.transform = `translate(${this.transform}px,0)`;
      });
    },
    setupHeight() {
      const widgetContainer = document.querySelector(`.${this.$options.name}_${this.widgetIndex}`);
      const completionContainer = document.querySelector(`.completion_${this.widgetIndex}`);
      const containerHeight = widgetContainer.clientHeight;
      completionContainer.style.height = `${containerHeight - 48}px`;
      completionContainer.style.maxHeight = `${containerHeight - 48}px`;
    },
  },
};
</script>
<style lang="sass">
.no__data
  margin-top: 0;
  margin: 8px;
  text-align: center;

.item__title
  font-size: 1rem;
  margin-bottom: 0.5rem;

.page__control
  color: #bfbfbf;

.page__control--active
  cursor: pointer;
  color: #20a8d8;

.completion__container
  overflow-y: auto;
  width: 100% !important;
  max-width: unset !important;

.completion__legend
  height: 50px;

.completion__list
  .control-button
    background-size: 35%
    background-repeat: no-repeat
    background-position: center

.control-button
  width: 2%;
  position: relative;
  cursor: pointer;

.control-button:hover
  background-color: #c6dcef !important;

.control-button
  span
    position: absolute;
    top: 45%;
    color: #606060;
    display: none;

.control-button
  .left
    right: 20%;

.control-button
  .right
    left: 20%;

.journey
  overflow: hidden

.completion__list
  .journey__container
    height: 100px

.journey__job
  position: relative
  min-width: 135px
  transition: transform .5s ease-in-out
  z-index: 1
  background-color: #868e96

  &.journey--progress
    background-color: #BDBDBD

    .journey__bar
      border-color: #28a745

    .journey__marker
      display: block

    .journey__percentage
      display: block

    .journey__percentage--bottom
      display: block

  &.journey--complete
    background-color: #28a745

    .journey__bar
      border-color: #28a745

  &.journey--pending
    background-color: #BDBDBD

    .journey__bar
      border-color: #BDBDBD

  &.last--complete
    background-color: #28a745

    .journey__bar
      border-color: #28a745

    .journey__marker
      display: block

    .journey__percentage
      display: block

.journey__bar
  position: relative
  border-width: 3px 0 3px 0
  border-style: solid
  border-color: #333

  &:first-child
    min-width: 20px

.journey__marker
  display: none
  position: absolute
  width: 30px
  height: 30px
  background-size: contain
  background-repeat: no-repeat
  background-position: center
  background-image: url('../../assets/ui/truck.png')
  margin-top: -25px
  z-index: 4
  right: 0
  cursor: pointer

.journey__percentage
  display: none
  position: absolute
  margin-top: -40px
  z-index: 4
  right: 0

.journey__percentage--bottom
  display: none
  position: absolute
  margin-top: 10px
  z-index: 4
  right: 0

.dot
  position: absolute
  width: 40px
  height: 40px
  background-size: contain
  background-repeat: no-repeat
  background-position: center
  background-image: url('../../assets/ui/marker.png')
  margin: -36px -9px 0 -9px
  z-index: 3

  &.dot--first
    left: 0

  &.dot--last
    right: 0
    cursor: pointer

.units__container
  padding: 5px

.shipment__percentage
  p
    font-size: 26px;
    margin-bottom: 0px;
    font-family: open sans,tahoma,sans-serif;
    font-weight: bold;

.shipment__number
  font-size: 13px;
  a
    font-family: open sans,tahoma,sans-serif;

.shipment__percentage
  span
    font-size: 20px !important;
    font-weight: normal !important;

.percentage__cont, .progress__cont
  height: 80px !important;

.progress__cont
  border: 1px solid #ccc;

.progress__cont:hover
  .control-button
    span
      display: block;
</style>



// WEBPACK FOOTER //
// src/components/dashboard_widgets/CompletionItems.vue